import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AclPermissionDetail } from '@y42/acl/models';
import { createAclPermissionDetail } from '@y42/acl/util/create-acl-permission-detail';
import { connectState, InputObservable } from '@y42/angular/util';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'y42-create-comment-button',
  templateUrl: './create-comment-button.component.html',
  styleUrls: ['./create-comment-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateCommentButtonComponent {
  @Input() active = false;

  @Input()
  @InputObservable()
  isCanvasEditable = createAclPermissionDetail({ allowed: false });
  private readonly isCanvasEditable$!: Observable<AclPermissionDetail>;

  @Output() readonly selectTool = new EventEmitter();

  readonly state = connectState(this, {
    isCanvasEditable: this.isCanvasEditable$,
  });
}
